import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { documentFileComponent } from './documentFile.component';
import { documentFileViewerComponent } from '../documentFileViewer/documentFileViewer.component';
import { validateSignDocumentComponent } from '../validateSignDocument/validateSignDocument.component';
import { DossierDetailModule } from '../../dossiers/components/dossierDetail.module';
import { TranslateModule } from '@ngx-translate/core';
import { PanelModule } from 'primeng-lts/panel';
import { CardModule } from 'primeng-lts/card';

@NgModule({
  declarations: [documentFileComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    RouterModule,
    WaitLoadingModule,
    DossierDetailModule,
    PanelModule,
    CardModule
  ],
  exports: [documentFileComponent]
})
export class DocumentFileModule { }
